export default __webpack_public_path__ + "static/media/product-3.8a712635.jpg";